import { Progress } from '@mantine/core'
import { TeamStats } from '../../teams/api'
import { Typography } from '../../common/typography'
import classes from './PerformanceOverview.module.css'

type ResultKey = 'matches_won' | 'matches_draw' | 'matches_lost'

function getWinDrawLossPercentage(data: TeamStats, key: ResultKey): number {
  const total = data.matches_won + data.matches_draw + data.matches_lost
  if (total === 0) return 0

  const value = data[key]
  return Math.round((value / total) * 100)
}

export default function MatchesPerformanceOverview({
  title,
  stats,
}: {
  title?: string
  stats: TeamStats
}) {
  return (
    <div className={classes.container}>
      {title && (
        <Typography
          level={3}
          fs="xl"
          fw={500}
          fc={{ light: 'black', dark: 'gray-3' }}
          lh="100"
        >
          {title}
        </Typography>
      )}

      <div className={classes.data_wrapper}>
        <Progress.Root classNames={{ root: classes.root }}>
          <Progress.Section
            value={getWinDrawLossPercentage(stats, 'matches_won')}
            color="#087F5B"
          >
            <Progress.Label>
              <Typography
                fw={500}
                fc={{ light: 'white', dark: 'gray-3' }}
                ff="JetBrains Mono"
                ta="center"
                lh="500"
              >
                {getWinDrawLossPercentage(stats, 'matches_won')}%
              </Typography>
            </Progress.Label>
          </Progress.Section>
          <Progress.Section
            value={getWinDrawLossPercentage(stats, 'matches_draw')}
            color="#495057"
          >
            <Progress.Label>
              <Typography
                fw={500}
                fc={{ light: 'white', dark: 'gray-3' }}
                ff="JetBrains Mono"
                ta="center"
                lh="500"
              >
                {getWinDrawLossPercentage(stats, 'matches_draw')}%
              </Typography>
            </Progress.Label>
          </Progress.Section>
          <Progress.Section
            value={getWinDrawLossPercentage(stats, 'matches_lost')}
            color="#C92A2A"
          >
            <Progress.Label>
              <Typography
                fw={500}
                fc={{ light: 'white', dark: 'gray-3' }}
                ff="JetBrains Mono"
                ta="center"
                lh="500"
              >
                {getWinDrawLossPercentage(stats, 'matches_lost')}%
              </Typography>
            </Progress.Label>
          </Progress.Section>
        </Progress.Root>
        <div className={classes.stats_wrapper}>
          <div className={classes.stat_box}>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ta="center"
              lh="125"
            >
              Played
            </Typography>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ff="JetBrains Mono"
              ta="center"
              lh="150"
            >
              {stats.total_matches}
            </Typography>
          </div>
          <div className={classes.stat_box}>
            <Typography
              fw={500}
              fc={{ light: 'white', dark: 'gray-3' }}
              ta="center"
              lh="125"
              className={classes.won}
            >
              Won
            </Typography>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ff="JetBrains Mono"
              ta="center"
              lh="150"
            >
              {stats.matches_won}
            </Typography>
          </div>
          <div className={classes.stat_box}>
            <Typography
              fw={500}
              fc={{ light: 'white', dark: 'gray-3' }}
              ta="center"
              lh="125"
              className={classes.draw}
            >
              Draw
            </Typography>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ff="JetBrains Mono"
              ta="center"
              lh="150"
            >
              {stats.matches_draw}
            </Typography>
          </div>
          <div className={classes.stat_box}>
            <Typography
              fw={500}
              fc={{ light: 'white', dark: 'gray-3' }}
              ta="center"
              lh="125"
              className={classes.lost}
            >
              Lost
            </Typography>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ff="JetBrains Mono"
              ta="center"
              lh="150"
            >
              {stats.matches_lost}
            </Typography>
          </div>
          <div className={classes.stat_box}>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ta="center"
              lh="125"
            >
              GF
            </Typography>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ff="JetBrains Mono"
              ta="center"
              lh="150"
            >
              {stats.goals_for}
            </Typography>
          </div>
          <div className={classes.stat_box}>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ta="center"
              lh="125"
            >
              GA
            </Typography>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ff="JetBrains Mono"
              ta="center"
              lh="150"
            >
              {stats.goals_against}
            </Typography>
          </div>
          <div className={classes.stat_box}>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ta="center"
              lh="125"
            >
              GD
            </Typography>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ff="JetBrains Mono"
              ta="center"
              lh="150"
            >
              {stats.goal_difference}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  )
}
